import React from 'react';

import {
  faFacebookSquare,
  faInstagramSquare,
  faWhatsappSquare,
} from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

import ButtonLink from './ButtonLink';

import '../assets/css/ClientCard.scss';

const gaCategory = process.env.REACT_APP_GA_CATEGORY;

const ClientCard = ({ pyme }) => {
  return (

    <div className="col-md-4 px-0">
      <div className="row mb-2 d-none d-sm-block">
        <strong style={{ color: '#6d6d6d' }}>¡Vamos a vitrinear!</strong>
      </div>
      <div className="row d-none d-sm-block">
        <h5 style={{ fontSize: '1.2rem' }}><strong>{pyme.namePyme}</strong></h5>
      </div>

      {typeof pyme.specialFactor !== 'undefined' ? (
        <div className="row">
          <p style={{ fontSize: '1rem' }}>
            {pyme.specialFactor}
          </p>
        </div>
      ) : null}

      <div className="row d-flex justify-content-center">
        {typeof pyme.webPyme !== 'undefined' &&
        pyme.webPyme !== null &&
        pyme.webPyme !== '' ? (
          <div
            className="col-12 my-1"
            style={{
              textAlign: 'center',
              paddingLeft: '0px',
              paddingRight: '0px',
            }}
          >
            <ButtonLink
              favicon={faGlobe}
              text="Ir al sitio web"
              link={pyme.webPyme}
              active="active-button"
              gaEvent={{
                category: gaCategory,
                label: pyme.namePyme,
                action: 'Click Sitio web',
              }}
            />
          </div>
        ) : null}
        {typeof pyme.instagramPyme !== 'undefined' &&
        pyme.instagramPyme !== null &&
        pyme.instagramPyme !== '' ? (
          <div
            className="col-12 my-1"
            style={{
              textAlign: 'center',
              paddingLeft: '0px',
              paddingRight: '0px',
            }}
          >
            <ButtonLink
              favicon={faInstagramSquare}
              text="Ver en Instagram"
              link={pyme.instagramPyme}
              active={typeof pyme.webPyme !== 'undefined' ? '': 'active-button'}
              gaEvent={{
                category: gaCategory,
                label: pyme.namePyme,
                action: 'Click Instagram',
              }}
            />
          </div>
        ) : null}
        {typeof pyme.facebookPyme !== 'undefined' &&
        pyme.facebookPyme !== null &&
        pyme.facebookPyme !== '' ? (
          <div
            className="col-12 my-1"
            style={{
              textAlign: 'center',
              paddingLeft: '0px',
              paddingRight: '0px',
            }}
          >
            <ButtonLink
              favicon={faFacebookSquare}
              text="Ver en Facebook"
              link={pyme.facebookPyme}
              active={typeof pyme.webPyme !== 'undefined' || typeof pyme.instagramPyme !== 'undefined' ? '': 'active-button'}
              gaEvent={{
                category: gaCategory,
                label: pyme.namePyme,
                action: 'Click Facebook',
              }}
            />
          </div>
        ) : null}
        {typeof pyme.whatsappPyme !== 'undefined' &&
        pyme.whatsappPyme !== null &&
        pyme.whatsappPyme !== '' ? (
          <div
            className="col-12 my-1"
            style={{
              textAlign: 'center',
              paddingLeft: '0px',
              paddingRight: '0px',
            }}
          >
            <ButtonLink
              favicon={faWhatsappSquare}
              text="Enviar Whatsapp"
              link={pyme.whatsappPyme}
              active={typeof pyme.webPyme !== 'undefined' || typeof pyme.instagramPyme !== 'undefined' || typeof pyme.facebookPyme !== 'undefined' ? '': 'active-button'}
              gaEvent={{
                category: gaCategory,
                label: pyme.namePyme,
                action: 'Click Whatsapp',
              }}
            />
          </div>
        ) : null}
      </div>

    </div>
  );
};

export default ClientCard;
